export default __webpack_public_path__ + "static/0233-5459e3afc9ccd0af6a1656dd58b03df8.png";